import objectAssign from 'object-assign';


export function workshop( state = { 
	post: {},
	fetching: {
		post: false,
		progress: false
	}
}, action ) {

	switch( action.type ) {

		case 'REQUEST_WORKSHOP':
			return Object.assign({}, state, {
				fetching: Object.assign({}, state.fetching, {post: true}),
			})

		case 'RECEIVE_WORKSHOP':
			return Object.assign({}, state, {
				post: action.workshop,
				fetching: Object.assign({}, state.fetching, {post: false}),
			})

		case 'REMOVE_WORKSHOP':
			return Object.assign({}, state, {
				post: {}
			})

		case 'REQUEST_WORKSHOP_PROGRESS':
			return Object.assign({}, state, {
				fetching: Object.assign({}, state.fetching, {progress: true}),
			})

		case 'RECEIVE_WORKSHOP_PROGRESS':

			let oldWorkshop = state.post,
				newWorkshop = action.workshop;

			if( 'title' in oldWorkshop ) {
				if( oldWorkshop.completed_card < newWorkshop.completed_card ) oldWorkshop.completed_card = newWorkshop.completed_card;
				if( oldWorkshop.completed !== newWorkshop.completed ) oldWorkshop.completed = newWorkshop.completed;
				if( oldWorkshop.reward_claimed !== newWorkshop.reward_claimed ) oldWorkshop.reward_claimed = newWorkshop.reward_claimed;
				if( oldWorkshop.recommended.length !== newWorkshop.recommended.length ) oldWorkshop.recommended = newWorkshop.recommended;
				if( !oldWorkshop.started && !!newWorkshop.started ) oldWorkshop.started = newWorkshop.started;
				if( !oldWorkshop.started_date && !!newWorkshop.started_date ) oldWorkshop.started_date = newWorkshop.started_date;
				if( !('cards' in oldWorkshop) ) oldWorkshop.cards = []

				if( oldWorkshop.cards.length === newWorkshop.cards.length ) {
					for (var c = oldWorkshop.cards.length - 1; c >= 0; c--) {
						oldWorkshop.cards[c].value = newWorkshop.cards[c].value
					}
				} else {
					oldWorkshop.cards = newWorkshop.cards;
				}
			} else {
				oldWorkshop = newWorkshop
			}

			return Object.assign({}, state, {
				post: oldWorkshop,
				fetching: Object.assign({}, state.fetching, {progress: false}),
			})

		case 'RECEIVE_WORKSHOP_RANKING':
			return Object.assign({}, state, {
				post: action.workshop
			})

		default:
			return state;

	}
	
}



// WEBPACK FOOTER //
// ./src/js/reducers/workshop.js